/**
 * helps pushing custom events to Google Tag Manager
 */
interface DataLayerObject {
  event: string;
}
declare global {
  interface Window {
    dataLayer: DataLayerObject[];
  }
}
// eslint-disable-next-line
export const genericGtmEvent = (event: string, payload: any) => gtmEventPush(event, payload);

export const EventTypes = {
  CLICK_SHARING_BUTTON: "CLICK_SHARING_BUTTON",
  USER_LOGIN: "USER_LOGIN",
  SHORTOFFER_SUBMIT_BUTTON_CLICK: "SHORTOFFER_SUBMIT_BUTTON_CLICK",
  PROVIDER_LIST_LOADED: "PROVIDER_LIST_LOADED",
  PROVIDER_LIST_PROVIDER_SELECTED: "PROVIDER_LIST_PROVIDER_SELECTED",
  TARIFF_LIST_TARIFF_SELECTED: "TARIFF_LIST_TARIFF_SELECTED",
  POSTAL_CODE_GIVEN: "POSTAL_CODE_GIVEN",
  LOCATION_GIVEN: "LOCATION_GIVEN",
  CONSUMPTION_GIVEN: "CONSUMPTION_GIVEN",
  CHANGESERVICE_BUTTON_CLICKED: "CHANGESERVICE_BUTTON_CLICKED",
  OFFER_LOADED: "OFFER_LOADED",
  OFFER_FAILED_TO_LOAD: "OFFER_FAILED_TO_LOAD",
  PRINT_BUTTON_CLICKED: "PRINT_BUTTON_CLICKED",
  REGISTER_CLICKED: "REGISTER_CLICKED",
  USER_REGISTERED: "USER_REGISTERED",
  USER_EMAIL_REGISTERED: "USER_EMAIL_REGISTERED",
  USER_SOCIAL_REGISTERED: "USER_SOCIAL_REGISTERED",
  PROMOTION_CODE_COPIED: "PROMOTION_CODE_COPIED",
  PROMOTION_CODE_ENTERED: "PROMOTION_CODE_ENTERED",
  PROMOTION_CODE_WRONG: "PROMOTION_CODE_WRONG",
  PROMOTION_BANNER_CLOSED: "PROMOTION_BANNER_CLOSED",
  SHORT_OFFER_PROPERTY_TYPE: "SHORT_OFFER_PROPERTY_TYPE",
  SHORT_OFFER_CATEGORY: "SHORT_OFFER_CATEGORY",
  SHORT_OFFER_ECOTARIFF: "SHORT_OFFER_ECOTARIFF",
  SHORT_OFFER_NEXT_BUTTON_CLICK: "SHORT_OFFER_NEXT_BUTTON_CLICK",
  SHORT_OFFER_SUCCESS: "SHORT_OFFER_SUCCESS",
  DASHBOARD_CLICK_THROUGH: "DASHBOARD_CLICK_THROUGH",
  DUPLICATE_COUNTER_NUMBER_ERROR_DISPLAYED: "DUPLICATE_COUNTER_NUMBER_ERROR_DISPLAYED",
  SIGNUP_LOGIN_PAGE: "SIGNUP_LOGIN_PAGE",
  SIGNUP_LOGIN_PAGE_SUBMIT_BUTTON_CLICK: "SIGNUP_LOGIN_PAGE_SUBMIT_BUTTON_CLICK",
  SIGNUP_LOGIN_PAGE_SECOND_STEP: "SIGNUP_LOGIN_PAGE_SECOND_STEP",
  SIGNUP_LOGIN_PAGE_ERROR: "SIGNUP_LOGIN_PAGE_ERROR",
  SIGNUP_LOGIN_PAGE_BACK_BUTTON_CLICK: "SIGNUP_LOGIN_PAGE_BACK_BUTTON_CLICK",
  BANNER_GLOBAL_CONSENT_CLICK: "BANNER_GLOBAL_CONSENT_CLICK",
  BANNER_COOKIE_SETTINGS_CLICK: "BANNER_COOKIE_SETTINGS_CLICK",
  COOKIE_CONSENT_AGREEMENT: "COOKIE_CONSENT_AGREEMENT",
  USER_CONSENTS_FUNCTIONAL_COOKIE: "USER_CONSENTS_FUNCTIONAL_COOKIE",
  USER_CONSENTS_MARKETING_COOKIE: "USER_CONSENTS_MARKETING_COOKIE",
  COOKIE_SETTINGS_DETAILS_OPEN_CLICK: "COOKIE_SETTINGS_DETAILS_OPEN_CLICK",
  TRIGGER_FOCUS_COOKIES_CONSENTS: "TRIGGER_FOCUS_COOKIES_CONSENTS",
  TRIGGER_FOCUS_CONSENTS_SETTINGS: "TRIGGER_FOCUS_CONSENTS_SETTINGS",
  SLIDER_SWIPE: "SLIDER_SWIPE",
  NEW_CTA_CLICKOUT: "NEW_CTA_CLICKOUT",
  AB_TESTING: "AB_TESTING",
  SOF_STEP_PROGRESSION: "SOF_STEP_PROGRESSION",
  OLD_SOF_STEP_PROGRESSION: "OLD_SOF_STEP_PROGRESSION",
  OLD_SOF_STEP_EMAIL: "OLD_SOF_STEP_PROGRESSION-STEP_6_EMAIL_ENTRY",
  VIDEO_PLAYER_EVENTS: "VIDEO_PLAYER_EVENTS",
  CS_FORM: "CS_FORM",
  CS_FORM_ERROR: "CS_FORM_ERROR",
  SO_FORM: "SO_FORM",
  SHORT_OFFER: "SHORT_OFFER",
  SHORT_OFFER_FORM_INTERACTION: "SHORT_OFFER_FORM_INTERACTION",
  FAQ_SEARCH_INTERACTION: "FAQ_SEARCH_INTERACTION",
  RMD_TRX: "RMD_TRX",
  CS_CREATED: "CS_CREATED",
  CS_ACTIVATED: "CS_ACTIVATED",
  CS_DEACTIVATED: "CS_DEACTIVATED",
  OFFER_CREATED: "OFFER_CREATED",
  USER_CREATED: "USER_CREATED",
};

export type EventT = (typeof EventTypes)[keyof typeof EventTypes];

export const gtmEventPush = <T = unknown, U = unknown>(type: EventT, payload?: T, logFn?: (...args: U[]) => void) => {
  window.dataLayer = window.dataLayer || [];
  const gtmEvent = { event: type, payload: payload ? payload : {} };
  window.dataLayer.push(gtmEvent);
  if (typeof logFn === "function") {
    logFn.call(gtmEvent, `Pushed event "${type}" to GTM DataLayer.` as unknown as U, gtmEvent as unknown as U);
  }
};

export const sliderSwipe = (id: string, slideNumber: number) =>
  gtmEventPush(EventTypes.SLIDER_SWIPE, { id, slideNumber });

export const videoPlayerEvents = (videoEvent: string) => {
  gtmEventPush(EventTypes.VIDEO_PLAYER_EVENTS, { Video_Event: videoEvent });
};

export const GoogleTagManager = {
  videoPlayerEvents,
};

export const shortOfferPropertyTypeClick = (PropertyType?: string) =>
  gtmEventPush(EventTypes.SHORT_OFFER_PROPERTY_TYPE, { PropertyType });

export const promotionCodeCopied = () => gtmEventPush(EventTypes.PROMOTION_CODE_COPIED);
